import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from '../../../styles/3ds2/main.module.css'
import GooglePayTokenPurchaseSample from '../samples/GooglePayTokenPurchaseSample'
import { makeCavvPreAuthRequest } from '../../../actions/threeDSTwoActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _3DS2, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const OBJECT = [ "googlePayTokenPurchase", "googlePayTokenPurchase", "$mpgTxn"]

const METHODS = {
    store_id: [".SetStoreId(store_id);", ".setStoreId(store_id);", "'store_id'=>$store_id"],
    api_token: [ ".SetApiToken(api_token);", ".setApiToken(api_token);", "'api_token'=>$api_token"],
    order_id: [ ".SetOrderId(order_id);", ".setOrderId(order_id);", "'order_id'=>$order_id"],
    amount: [ ".SetAmount(amount);", ".setAmount(amount);", "'amount'=>$amount"],
    data_key: [ "SetData(data_key);", "setData(data_key);", ""],
    expiry_date: [ ".SetExpdate(expiry_date);", ".setExpDate(expiry_date);", "'expiry_date'=>$expiry_date"],
    CAVV: [ ".SetCavv(cavv);", ".setCavv(cavv);", "cavv=>$cavv"],
    commerce_indicator: [ ".SetCryptType(crypt);", ".setCryptType(crypt);", "'crypt'=>$crypt"],
    _3DS_version: [ ".SetThreeDSVersion(\"3DS_Version\");", ".setThreeDSVersion(\"3DS_Version\");", "'threeds_version'=>$threeds_version"],
    _3DS_server: [ ".SetThreeDSServerTransId(\"3DS_Server_Trans_Id\");", ".setThreeDSServerTransId(\"3DS_Server_Trans_Id\");", "'threeds_server_trans_id'=>$threeds_server_trans_id"],
    network: [ ".SetNetwork(network);", ".setNetwork(network);", "$network = \"MASTERCARD\";"],
    data_type: [ ".SetDataType(data_type);", ".setDataType(data_type);", ""],
    status_check: [ ".SetStatusCheck(status_check);", ".setStatusCheck(status_check);", "$mpgHttpPost = new mpgHttpsPostStatus($store_id,$api_token,$status,$mpgRequest);"],
    customer_ID: [ ".SetCustId(cust_id);", ".setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: [ ".SetDynamicDescriptor(dynamic_descriptor);", ".setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
    card_match_ID: [ ".SetCmId(transaction_id);", ".setCmId(transaction_id);", "'cm_id' => $transaction_id"],
    Customer_Information: [ ".SetCustInfo(customer);", ".setCustInfo(customer);", "->setCustInfo($mpgCustInfo);"],
    AVS_Information: [ ".SetAvsInfo(avsCheck);", ".setAvsInfo(avsCheck);", "->setAvsInfo($mpgAvsInfo);"],
    CVD_Information: [ ".SetCvdInfo(cvdCheck);", ".setCvdInfo(cvdCheck);", "->setCvdInfo($mpgCvdInfo);"],
    Convenience_Fee_Information: [ ".SetConvFeeInfo(convFeeInfo);", ".setConvenienceFee(convFeeInfo);", "$mpgConvFee = new mpgConvFeeInfo($convFeeTemplate);"],
    Recurring_Billing: [ ".SetRecur(recurring_cycle);", ".setRecurInfo(recurInfo);", "->setRecur($mpgRecur);"],
    wallet_indicator: [ ".SetWalletIndicator(wallet_indicator);", ".setWalletIndicator(wallet_indicator);", "'wallet_indicator'=>$wallet_indicator"],
    cof: [ ".SetCofInfo(cof);", ".setCofInfo(cof);", "->setCofInfo($cof);"],
    ds_trans_id: [".SetDsTransId(\"DsTransId\");", ".setDsTransId(\"DsTransId\");", "'ds_trans_id' => $ds_trans_id"],

    // cof methods:
    issuer_ID: [ "cof.SetIssuerId(\"VALUE_FOR_ISSUER_ID\");", "cof.setIssuerId(\"VALUE_FOR_ISSUER_ID\");", "$cof->setIssuerId(\"VALUE_FOR_ISSUER_ID\");"],
    payment_indicator: [ "cof.SetPaymentIndicator(\"PAYMENT_INDICATOR_VALUE\");", "cof.setPaymentIndicator(\"PAYMENT_INDICATOR_VALUE\");", "$cof->setPaymentIndicator(\"PAYMENT_INDICATOR_VALUE\");"],
    payment_information: [ "cof.SetPaymentInformation(\"PAYMENT_INFO_VALUE\");", "cof.setPaymentInformation(\"PAYMENT_INFO_VALUE\");", "$cof->setPaymentInformation(\"PAYMENT_INFO_VALUE\");"],
}

class GooglePayTokenPurchase extends Component {
    state = {
        topRef: React.createRef()
    }

    generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    getOrderId() {
        const { order_id } = this.props;
        if(order_id === "none")
            return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
        else
            return `"${order_id}"`;
    }

    async onCavvPreAuthPress() {
        const { cavvPreAuthSuccess, loading } = this.props;
        const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci } = this.props;

        if(loading || cavvPreAuthSuccess || eci === cavv) return;

        if(order_id === 'none') {
            const newOrderId = await this.generateOrderId();
            this.props.updateOrderId({ featureId: _3DS2, orderId: newOrderId });
        }
        const cavvPreAuthRequest = { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci };
        this.props.makeCavvPreAuthRequest(cavvPreAuthRequest);
    }

    renderBtn() {
        const { loading, cavvPreAuthSuccess, eci, cavv } = this.props;
        if(!(loading || cavvPreAuthSuccess || eci === cavv)) {
            return (
                <div  style={{marginLeft: '20%'}} className={"requestButton"} onClick={() => this.onCavvPreAuthPress()}>
                    Cavv Pre-Auth Request
                </div>
            );
        }
        else {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'left'}}>
                     <div className="disabledButton">
                        Cavv Pre-Auth Request
                     </div>
                     <i style={{marginLeft: '1vw', fontSize: '0.8rem', color: 'red'}}>* To make this request you need to get cavv and eci (crypt type) by making 3DS Auth request.</i>
                </div>
            );
        }
    }

    renderInteractiveTool() {
        const { leftContents } = styles;
        return (
            <div className={leftContents}>
                <div ref={this.state.topRef} style={{ paddingLeft: '1vw', paddingRight: '2vw', marginBottom: '10%'}}>
                    <h3 style={{ marginTop: '7vh'}}>Sample Pre-Authorization with 3-D Secure – cavvPreauth</h3>
                    {this.renderBtn()}
                </div>
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <div ref={this.state.topRef}>
                    <span className="stepPageTitle"><b>Google Pay™ Token Purchase</b></span>
                    
                    <p>The Google Pay™ Token Purchase transaction is utilized after passing a GooglePay account into a temporary token using our GooglePay Token Temporary Add then performing 3DS authentication with the token. This transaction verifies funds on the customer’s card, removes the funds and prepares them for deposit into the merchant’s account.</p>
                    <p>To perform the 3-D Secure authentication, the Moneris MPI or any third-party MPI may be used.</p>
                    <p>Refer to Apple or Google developer portals for details on integrating directly to their wallets to retrieve the payload data.</p>

                    <p><b>Google Pay™ Token Purchase for transaction object definition</b></p>
                    {(() => {
                    switch(progLangId) {
                        case _DOTNET:
                            return <code>GooglePayTokenPurchase googlePayTokenPurchase = new GooglePayTokenPurchase();</code>
                        case _JAVA:
                            return <code>GooglePayTokenPurchase googlePayTokenPurchase = new GooglePayTokenPurchase();</code>
                        case _PHP:
                            return <code>{"$txnArray = array(‘type’=>’googlePayTokenPurchase', …);"}<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                        default:
                            return null
                        }
                    })()}

                    <p style={{ marginTop: '5vh' }}><b>HttpsPostRequest object for Google Pay™ Token Preauth transaction</b></p>
                    {(() => {
                        switch(progLangId) {
                            case _DOTNET:
                                return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(googlePayTokenPurchase);</code>
                            case _JAVA:
                                return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(googlePayTokenPurchase);</code>
                            case _PHP:
                                return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                            default:
                                return null
                        }
                    })()}

                    <h3 style={{ marginTop: '10vh'}}>Core connection object fields (all API transactions)</h3>
                    <table className='four_cols_table'>
                        <th>Variable Name</th>
                        <th>Description</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>store ID</td>
                            <td>Unique identifier provided by Moneris upon merchant account setup</td>
                            <td><i>String</i><br /><br /> N/A</td>
                            <td><code>{progLangId !== _PHP ? 'mpgReq' : ''}{METHODS.store_id[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>API token</td>
                            <td>Unique alphanumeric string assigned by Moneris upon merchant account activation</td>
                            <td><i>String</i><br /><br /> N/A</td>
                            <td><code>{progLangId !== _PHP ? 'mpgReq' : ''}{METHODS.api_token[progLangId]}</code></td>
                        </tr>
                    </table>

                    <h3 style={{ marginTop: '7vh'}}>Google Pay™ Token Purchase transaction request fields – Required</h3>
                    <p>For a full description of mandatory and optional values, see Appendix A Definition of Request Fields.</p>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>order ID</td>
                            <td><i>String</i><br /><br /> 50-character alphanumeric<br /><br />a-Z A-Z 0-9 _ - : . @ spaces</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.order_id[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>data key</td>
                            <td><i>String</i><br /><br />25-character alphanumeric</td>
                            <td>{progLangId !== _PHP ? <code>{OBJECT[progLangId]}{METHODS.data_key[progLangId]}</code> : ''}<br /><br /><p>The temporary token returned by a GooglePayTokenTempAdd request.</p></td>
                        </tr>
                        <tr>
                            <td>amount</td>
                            <td><i>String</i><br /><br /> 10-character decimal<br /><br />Up to 7 digits (dollars) + decimal point (.) + 2 digits (cents) after the decimal point<br /><br />Example: 1234567.89</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.amount[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>Cardholder Authentication Verification Value (CAVV)<br /><br /><p className="note"><b>NOTE: </b> For Google Pay™ Token Purchase transactions, CAVV field contains the 3DS cryptogram only when 3DS is used prior. If you elected to skip 3DS Authentication, you may omit the CAVV field.</p></td>
                            <td><i>String</i><br /><br /> 50-character alphanumeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.CAVV[progLangId]}</code><br /><br /><p><strong>The 3DS cryptogram.</strong></p><p><strong>Sent in all financial transactions with 3-D Secure, including Verified By Visa, MasterCard SecureCode, American Express SafeKey</strong></p></td>
                        </tr>
                        <tr>
                            <td>electronic commerce indicator<br /><br /><p className="note"><b>NOTE: </b>For Google Pay™ Token Purchase and Token Pre-Authorization transactions using 3DS Authenitication, use the e-ommerce indicator obtained from your 3DS Authentication.</p></td>
                            <td><i>String</i><br /><br /> 1-character alphanumeric</td>
                            <td>
                                <code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.commerce_indicator[progLangId]}</code>
                                <p>Describes the category of e-commerce transaction being processed. Allowable values are:</p>
                                <p>1 – Mail Order / Telephone Order—Single</p>
                                <p>2 – Mail Order / Telephone Order—Recurring</p>
                                <p>3 – Mail Order / Telephone Order—Instalment</p>
                                <p>4 – Mail Order / Telephone Order—Unknown classification</p>
                                <p>5 – Authenticated e-commerce transaction (3-D Secure)</p>
                                <p>6 – Non-authenticated e-commerce transaction (3-D Secure)</p>
                                <p>7 – SSL-enabled merchant</p>
                                <p><strong>In Credential on File transactions where the request field e-commerce indicator is also being sent:</strong> the allowable values for e-commerce indicator are dependent on the value sent for payment indicator, as follows:</p>
                                <p>if payment indicator = R, then allowable values for e-commerce indicator: 2, 5 or 6</p>
                                <p>if payment indicator = V, then allowable values for e-commerce indicator: 2, 5 or 6</p>
                                <p>if payment indicator = C, then allowable values for e-commerce indicator: 1, 5, 6 or 7</p>
                                <p>if payment indicator = U, then allowable values for e-commerce indicator: 1 or 7</p>
                                <p>if payment indicator = Z, then allowable values for e-commerce indicator: 1, 5, 6 or 7</p>
                            </td>
                        </tr>
                        <tr>
                            <td>3DS server transaction ID<br /><br /><p className="note"><b>NOTE: </b> Obtained from the Cavv Lookup request or MPI 3DS Authentication request. For Google Pay™ Token Purchase and Token Pre-Authorization transactions that do not use 3DS Authentication, you may omit the 3DS Server Transaction ID.</p></td>
                            <td><i>String</i><br /><br /> 36-character numeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS._3DS_server[progLangId]}</code><br /><br /><p><strong>Data is obtained from a Cavv Lookup Request or MPI 3DS Authentication Request transaction</strong></p></td>
                        </tr>
                        <tr>
                            <td>3DS Version <br /><p className="note"><b>NOTE: </b>Mandatory for financial transactions using 3rd Party 3-D Secure services. If you elected to skip 3DS Authentication, you may omit the 3DS Version field.</p></td>
                            <td><i>String</i><br /><br /> 10-character numeric</td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS._3DS_version[progLangId]}</code><br/><br/>
                            <strong>Acceptable values:</strong><br />2.0.0 = 3DS protocol 2.0.0<br />2.1.0 = 3DS protocol 2.1.0<br />2.2.0 = 3DS protocol 2.2.0<br />2.3.0 = 3DS protocol 2.3.0
                            </td>
                        </tr>
                        <tr>
                            <td>network</td>
                            <td><i>String</i><br /><br /> alphabetic</td>
                            <td><code>{OBJECT[progLangId]}{METHODS.network[progLangId]}</code><br />Card Brand name.<br />Field is case sensitive Possible values:<br />Visa<br />Mastercard<br />American Express<br />Interac<br />Discover</td>
                        </tr>
                    </table>
                
                    <h3 style={{ marginTop: '10vh'}}>Google Pay™ Token Purchase transaction request fields – Optional</h3>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>customer ID</td>
                            <td><i>String</i><br /><br /> 50-character alphanumeric<br /><p className="note"><strong>NOTE:</strong><br />Some special characters are not allowed:<br />{'< > $ % = ? ^ { } [ ] \\'}</p></td>
                        <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.customer_ID[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>dynamic descriptor</td>
                            <td><i>String</i><br /><br /> 20-character alphanumeric<br /><br />total of 22 characters including your merchant name and separator<br /><p className="note"><strong>NOTE:</strong><br />Some special characters are not allowed:<br />{'< > $ % = ? ^ { } [ ] \\'}</p></td>
                            <td><code>{progLangId !== _PHP ? OBJECT[progLangId] : ''}{METHODS.dynamic_descriptor[progLangId]}</code></td>
                        </tr>
                    </table>
                </div>
                <GooglePayTokenPurchaseSample />
            </div>
        )
    }

    render() {
        // return this.renderDocument();
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderInteractiveTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci } = state.threeDSTwo.main.config;
    const { loading, cavvPreAuthSuccess, cavvLookupSuccess } = state.threeDSTwo.main;
    const { mode } = state.common.sideNav;
    const { selection } = state.threeDSTwo.stepsList;
    return { cavvPreAuthSuccess, cavvLookupSuccess, selectedStep: selection, mode, loading, storeId, apiToken, order_id, pan, expdate, amount, cavv, eci, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makeCavvPreAuthRequest, updateOrderId})(GooglePayTokenPurchase)
